export const SAVE_DOMAIN_CHANGES_REQUEST = 'SAVE_DOMAIN_CHANGES_REQUEST';
export const SAVE_DOMAIN_CHANGES_ERROR = 'SAVE_DOMAIN_CHANGES_ERROR';
export const SAVE_DOMAIN_CHANGES_SUCCESS = 'SAVE_DOMAIN_CHANGES_SUCCESS';

export const SAVE_IMAGES_CHANGES_REQUEST = 'SAVE_IMAGES_CHANGES_REQUEST';
export const SAVE_IMAGES_CHANGES_ERROR = 'SAVE_IMAGES_CHANGES_ERROR';
export const SAVE_IMAGES_CHANGES_SUCCESS = 'SAVE_IMAGES_CHANGES_SUCCESS';

export const APPROVE_CURRENT_DOMAIN_REQUEST = 'APPROVE_CURRENT_DOMAIN_REQUEST';
export const APPROVE_CURRENT_DOMAIN_ERROR = 'APPROVE_CURRENT_DOMAIN_REQUEST';
